import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PaymentMethodDetail } from "@/features/my/settings/account/billing/payments/payment-methods/detail";
import { maskSearchFragment } from "@/features/shared/route-masking";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/payments/$paymentMethodId",
)({
  component: PaymentMethodDetail,
  validateSearch: z.object({
    updated: z.coerce.boolean().optional(),
    ...maskSearchFragment,
  }),
});
